/* eslint-disable react/no-unescaped-entities */
/**
 * Public landing — FONBEX V1 (Phase 2).
 * Wraps the validated Landing A design.
 */
import React from "react";
import LandingA from "@/fonbex/LandingA";

export default function LandingPage() {
  return <LandingA />;
}
